import { Type } from '@angular/core';

import type { ZodType } from 'zod';

import { createProviderToken } from '@core/common-legacy';

export interface ToolResultRenderer<T = unknown> {
  readonly toolName: string;
  readonly schema: ZodType<T>;
  readonly component: Type<{ payload: T }>;
}

export const {
  provide: provideTellentToolResultRenderer,
  inject: injectTellentToolResultRenderers,
} = createProviderToken<ToolResultRenderer>('TELLENT_TOOL_RESULT_RENDERERS')(true);
